import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 400px;
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.regular};
    margin-top: 12px;
    text-align: center;
  `}

  p:not(:first-child) {
    margin: 4px 0 0 0;
  }
`;
